module.exports = __webpack_public_path__ + "img/address-confirmation.75a46c70.svg";